module.exports = __webpack_public_path__ + "img/Astana.2cf9e4e8.png";